import { cn } from "@/lib/utils";

const ContentBox = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <div
      className={cn(
        "flex w-full p-10 flex-col justify-center items-center gap-2.5 rounded-sm border border-neutral-300",
        className,
      )}
    >
      {children}
    </div>
  );
};

export default ContentBox;
